import React, { useState } from "react";
import styles from "./GuestRsvpTidbits.module.css";
import {
  Box,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { List } from "antd";
import { HiOutlineUser } from "react-icons/hi2";
import { FaPen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
const GuestRsvpTidbits = () => {
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [tidbids, setTidbids] = useState(
    RSVP?.tidbits?.length > 0 ? RSVP?.tidbits : []
  );

  console.log("RSVP", RSVP);

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem} key={index}>
        <div className={styles.subListItem}>
          <div>
            <HiOutlineUser className={styles.listIcon} />
          </div>
          <div className={styles.listContent}>
            <TextComponent text={item?.name} textClass={styles.listname} />
            <div className={styles.mealDiv}>
              <TextComponent text={"Meal: "} textClass={styles.mealText} />
              <TextComponent
                text={item?.selectMeal?.val}
                textClass={styles.mealName}
              />
            </div>
          </div>
        </div>
        <FaPen
          className={styles.penIcon}
          onClick={() =>
            navigate("/RsvpAddMeal", {
              state: { headrTitle: "RSVP" },
            })
          }
        />
      </div>
    );
  };

  const onNextClick = () => {
    const notAnswered = tidbids?.find((item) => !item.answer);
    console.log(notAnswered);
    if (notAnswered) {
      dispatch(
        showAlert({
          type: "error",
          message: "Please answer all tidbits questions",
        })
      );
    } else if (!RSVP?.atendeeArr || RSVP?.atendeeArr?.length <= 0) {
      dispatch(
        showAlert({
          type: "error",
          message: "Please add meal info and attendees name",
        })
      );
    } else {
      dispatch(setRSVP({ ...RSVP, tidbits: tidbids }));
      navigate("/RsvpSubmit", {
        state: { headrTitle: "RSVP" },
      });
    }
  };
  return (
    <div className={styles.mainCont}>
      <Box boxClass={styles.subCont}>
        <TextComponent text={"Tidbits"} textClass={styles.heading} />
        <List
          dataSource={tidbids}
          className={styles.list}
          renderItem={(item, index) => {
            return (
              <div className={styles.TB_listItem}>
                <TextComponent
                  text={item?.question}
                  textClass={styles.TB_Ques}
                />
                {/* <div className={styles.TB_answer}> */}
                {/* <TextComponent text={item?.answer} /> */}
                <InputField
                  type="text"
                  placeholder="Write your answer"
                  inputWidth="100%"
                  onChange={(e) =>
                    setTidbids((prev) => {
                      let cpy = [...prev];
                      cpy[index].answer = e.target.value;
                      return cpy;
                    })
                  }
                  value={item?.answer}
                />
                {/* </div> */}
              </div>
            );
          }}
        />
        <div className={styles.mealSelectionHeader}>
          <TextComponent
            text={
              "Please provide the names and meal selection for your group invitation"
            }
            textClass={styles.mealSelectionHeading}
          />
          <div
            className={styles.addBtn}
            onClick={() => {
              dispatch(setRSVP({ ...RSVP, tidbits: tidbids }));
              navigate("/RsvpAddMeal", {
                state: { headrTitle: "RSVP" },
              });
            }}
          >
            <TextComponent text={"+ Add"} />
          </div>
        </div>
        <List
          dataSource={RSVP?.atendeeArr?.length > 0 ? RSVP?.atendeeArr : []}
          className={styles.list}
          renderItem={renderItem}
        />
        <div className={styles.btnDiv}>
          <SubmitButton
            title={"Next"}
            btnClass={styles.btn}
            onClick={onNextClick}
          />
        </div>
      </Box>
    </div>
  );
};

export default GuestRsvpTidbits;
